<template>
  <div>
    <suppliers-index />
  </div>
</template>

<script>
import SuppliersIndex from '../../views/suppliers/SuppliersIndex.vue'
export default {
  name: 'AzSuppliers',
  components: { SuppliersIndex }
}
</script>
